import { j as o } from "./AccesRecoveryIcon-CUPieIxT.js";
const s = () => /* @__PURE__ */ o.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", transform: "scale(-1 1)", children: /* @__PURE__ */ o.jsx("path", { d: "M16.59 8.295 12 12.875l-4.59-4.58L6 9.705l6 6 6-6z" }) });
export {
  s as C
};
